import { createValidator, maxLength, required } from 'util/validation'

import { ErrataNotaComplementarModel } from './model-errataNotaComplementar'

export const DESCRICAO_ERRATA_NOTA_COMPLEMENTAR_MAX_LENGTH = 1000

export const validateErrataNotaComplementar = createValidator<ErrataNotaComplementarModel>({
  justificativa: [required],
  descricao: [required, maxLength(DESCRICAO_ERRATA_NOTA_COMPLEMENTAR_MAX_LENGTH)],
})
